import { AccountCreate, AccountEdit } from './Accounts.entity';

export const INITIAL_ACCOUNT_CREATE: AccountCreate = {
  confirmPassword: '',
  employeeId: null,
  password: '',
  roleId: null,
  userName: '',
};

export const INITIAL_ACCOUNT_EDIT: AccountEdit = {
  employeeId: null,
  roleId: null,
  userName: '',
};
